module.exports = __webpack_public_path__ + "img/img_xinshou_5.58321f0f.png";